const TruckDesc = () => {
    return (
      <div className="px-6 py-10 max-w-7xl mx-auto">
        {/* Título principal */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#8B0000]">Nuestros Camiones</h1>
          <p className="text-xl text-gray-600 mt-2">Flota moderna y equipada para cualquier desafío</p>
        </div>
  
        {/* Cards de camiones */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Camión 1 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <img
              src="/camiones/camion 1.jpg"
              alt="Camión de carga pesada"
              className="w-full h-56 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">Camión de Carga Pesada</h2>
              <p className="text-gray-600">
                Ideal para mudanzas de gran volumen. Equipado con suspensión reforzada y sistema de amarre para cargas delicadas.
              </p>
            </div>
          </div>
  
          {/* Camión 2 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <img
              src="/camiones/camion2.jpg"
              alt="Camión urbano"
              className="w-full h-56 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">Camión Urbano</h2>
              <p className="text-gray-600">
                Perfecto para traslados dentro de la ciudad. Compacto, maniobrable y con capacidad media.
              </p>
            </div>
          </div>
  
          {/* Camión 3 */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <img
              src="/camiones/camion 6.jpg"
              alt="Camión refrigerado"
              className="w-full h-56 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">Camión Refrigerado</h2>
              <p className="text-gray-600">
                Diseñado para transportar productos que requieren temperatura controlada. Ideal para alimentos o medicamentos.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default TruckDesc;
  